module.exports = "https://web-assets.ifttt.com/packs/media/docs/action1-9f196389.png";